/**
 * src/components/directory/CategoryGrid.js
 *
 * Grilla de CategoryCards con filtrado reactivo.
 * Props: { categories: Array<Category>, searchTerm: Signal<string> }
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { effect } from '@core/signal.js'

define('CategoryGrid', ({ categories = [], searchTerm }) => {
    const grid = h('div', { className: 'cat-grid' })
    const empty = h('p', { className: 'cat-grid__empty' }, 'No se encontraron categorías.')

    const isSignal = v => v && typeof v.get === 'function'

    effect(() => {
        const term = searchTerm ? searchTerm.get() : ''
        const list = isSignal(categories) ? categories.get() : categories
        const filtered = term
            ? list.filter(cat => cat.name.toLowerCase().includes(term))
            : list

        while (grid.firstChild) grid.removeChild(grid.firstChild)

        if (filtered.length === 0) {
            grid.appendChild(empty)
        } else {
            filtered.forEach(cat => grid.appendChild(c('CategoryCard', cat)))
        }
    })

    return grid
})
